import tree from "../../../../components/tree.vue"
import iColumn from "../../../../components/Column.vue";
import iTable from "../../../../components/Table.vue";
import IPagination from "../../../../components/pagination.vue";
import scheduleTransfer from "../../../../components/scheduleTransfer.vue";
import moment from "moment";
// import { emailRule } from '@/utility/index.js'

export default {
  name: "ShiftSetting",
  components: { tree, iColumn, iTable, IPagination, scheduleTransfer },
  data() {
    return {
      formInline: {
        schedulingName: '',
        shiftId: ''
      },
      shiftList: [],
      // dialogVisible: false,
      // height: '550',
      list: [],
      // option: {
      //   stripe: true,
      //   border: true,
      //   loading: false,
      //   highlightCurrentRow: false,
      //   mutiSelect: true,
      //   serialNumber: true,
      // },
      // columns: [
      //   {
      //     prop: "schedulingName",
      //     label: this.$t('ShiftSchedule.schedulName'),
      //     align: "center",
      //     width: "200px"
      //   },
      //   {
      //     prop: "applicationShift",
      //     label: this.$t('ShiftSchedule.applicationShift'),
      //     align: "center",
      //     width: "200px"
      //   },
      //   {
      //     prop: "assertDate",
      //     label: this.$t('ShiftSchedule.applicationDate'),
      //     align: "center",
      //     // width: '100px',
      //     render: (h, params) => {
      //       console.log(h, params)
      //       return h('div', [
      //         h('span',{
      //           style: {
      //             wordBreak: 'break-word',
      //           },
      //         }, params.row.applicationShift),
      //         h('el-button', {
      //           props: {
      //             size: 'mini',
      //             type: 'primary'
      //           },
      //           style: {
      //             marginLeft: '10px'
      //           },
      //           on: {
      //             click: () => {
      //               console.log(params.row)
                    
      //               // this.handleButtonClick(params.row)
      //             }
      //           }
      //         }, '更多')
      //       ])
      //     }
      //   },
      //   {
      //     prop: "applicationCar",
      //     label: this.$t('ShiftSchedule.applicationVehicles'),
      //     align: "center",
      //     // width: "200",
      //   },
      //   {
      //     prop: "applicationDriver",
      //     label: this.$t('ShiftSchedule.applicationDriver'),
      //     align: "center",
      //     // width: "200",
      //   }
      // ],
      // operates: {
      //   width: 120,
      //   fixed: "right",
      //   list: [
      //      {
      //         id: '1',
      //         show: true,
      //         icon: 'el-icon-edit-outline',
      //         plain: true,
      //         disabled: false,
      //         isBtn: "REPAIRFORM_DETAIL",
      //         method: (index, row) => {
      //           this.id = row.id
      //           this.dialogFormVisible = true;
      //           this.diaTitle = this.$t('common.btn.edit')
      //           this.btnType = 'edit'
      //           this.isDisabled = false
      //           this.$nextTick(() => {
      //             this.$refs.form.clearValidate()
      //             this.form.shiftName = row.shiftName
      //             this.form.shiftType = row.shiftType
      //             if(this.form.shiftType == 1) {
      //               this.isShow = true
      //               this.isTime = false
      //               this.isDisplay = false
      //               let [startTime1, endTime1] = row.timeDescription.split('-');
      //               this.form.startTime1 = startTime1
      //               this.form.endTime1 = endTime1
      //               let [startHour1, startMin1] = this.form.startTime1.split(':').map(Number);
      //               let [endHour1, endMin1] = this.form.endTime1.split(':').map(Number);
      //               this.hour = Math.floor(endHour1-startHour1)
      //               this.min = Math.floor(endMin1-startMin1)
      //             }else if(this.form.shiftType == 2) {
      //               this.isShow = true
      //               this.isTime = true
      //               this.isDisplay = false
      //               let [Time1, Time2] = row.timeDescription.split(' ');
      //               console.log(Time1, Time2)
      //               let [startTime1, endTime1] = Time1.split('-');
      //               this.form.startTime1 = startTime1
      //               this.form.endTime1 = endTime1
      //               let [startTime2, endTime2] = Time2.split('-');
      //               this.form.startTime2 = startTime2
      //               this.form.endTime2 = endTime2
      //               let [startHour1, startMin1] = this.form.startTime1.split(':').map(Number);
      //               let [endHour1, endMin1] = this.form.endTime1.split(':').map(Number);
      //               let [startHour2, startMin2] = this.form.startTime2.split(':').map(Number);
      //               let [endHour2, endMin2] = this.form.endTime2.split(':').map(Number);
      //               this.hour = Math.floor(endHour1-startHour1) + Math.floor(endHour2-startHour2)
      //               this.min = Math.floor(endMin1-startMin1) + Math.floor(endMin2-startMin2)
      //             }else {
      //               this.isShow = true
      //               this.isTime = true
      //               this.isDisplay = true
      //               let [Time1, Time2, Time3] = row.timeDescription.split(' ');
      //               let [startTime1, endTime1] = Time1.split('-');
      //               this.form.startTime1 = startTime1
      //               this.form.endTime1 = endTime1
      //               let [startTime2, endTime2] = Time2.split('-');
      //               this.form.startTime2 = startTime2
      //               this.form.endTime2 = endTime2
      //               let [startTime3, endTime3] = Time3.split('-');
      //               this.form.startTime3 = startTime3
      //               this.form.endTime3 = endTime3
      //               let [startHour1, startMin1] = this.form.startTime1.split(':').map(Number);
      //               let [endHour1, endMin1] = this.form.endTime1.split(':').map(Number);
      //               let [startHour2, startMin2] = this.form.startTime2.split(':').map(Number);
      //               let [endHour2, endMin2] = this.form.endTime2.split(':').map(Number);
      //               let [startHour3, startMin3] = this.form.startTime3.split(':').map(Number);
      //               let [endHour3, endMin3] = this.form.endTime3.split(':').map(Number);
      //               this.hour = Math.floor(endHour1-startHour1) + Math.floor(endHour2-startHour2) + Math.floor(endHour3-startHour3)
      //               this.min = Math.floor(endMin1-startMin1) + Math.floor(endMin2-startMin2) + Math.floor(endMin3-startMin3)
      //             }
      //           })
      //         }
      //     },
      //     {
      //         id: '2',
      //         show: true,
      //         icon: 'el-icon-delete',
      //         plain: true,
      //         disabled: false,
      //         isBtn: "REPAIRFORM_DETAIL",
      //         method: (index, row) => {
      //           console.log(row)
      //           this.id = row.id
      //           this.deleteShift()
      //             // this.requestSerialNumber = row.requestSerialNumber
      //             // this.deleteRepair()
      //         }
      //     },
      //     {
      //         id: '3',
      //         show: true,
      //         icon: 'iconfont iconicon-chakanxq',
      //         plain: true,
      //         disabled: false,
      //         isBtn: "REPAIRFORM_DETAIL",
      //         method: (index, row) => {
      //           this.id = row.id
      //           this.dialogFormVisible = true;
      //           this.diaTitle = this.$t('common.btn.detail')
      //           this.btnType = 'detail'
      //           this.isDisabled = true
      //           this.$nextTick(() => {
      //             this.$refs.form.clearValidate()
      //             this.form.shiftName = row.shiftName
      //             this.form.shiftType = row.shiftType
      //             if(this.form.shiftType == 1) {
      //               this.isShow = true
      //               this.isTime = false
      //               this.isDisplay = false
      //               let [startTime1, endTime1] = row.timeDescription.split('-');
      //               this.form.startTime1 = startTime1
      //               this.form.endTime1 = endTime1
      //               let [startHour1, startMin1] = this.form.startTime1.split(':').map(Number);
      //               let [endHour1, endMin1] = this.form.endTime1.split(':').map(Number);
      //               this.hour = Math.floor(endHour1-startHour1)
      //               this.min = Math.floor(endMin1-startMin1)
      //             }else if(this.form.shiftType == 2) {
      //               this.isShow = true
      //               this.isTime = true
      //               this.isDisplay = false
      //               let [Time1, Time2] = row.timeDescription.split(' ');
      //               console.log(Time1, Time2)
      //               let [startTime1, endTime1] = Time1.split('-');
      //               this.form.startTime1 = startTime1
      //               this.form.endTime1 = endTime1
      //               let [startTime2, endTime2] = Time2.split('-');
      //               this.form.startTime2 = startTime2
      //               this.form.endTime2 = endTime2
      //               let [startHour1, startMin1] = this.form.startTime1.split(':').map(Number);
      //               let [endHour1, endMin1] = this.form.endTime1.split(':').map(Number);
      //               let [startHour2, startMin2] = this.form.startTime2.split(':').map(Number);
      //               let [endHour2, endMin2] = this.form.endTime2.split(':').map(Number);
      //               this.hour = Math.floor(endHour1-startHour1) + Math.floor(endHour2-startHour2)
      //               this.min = Math.floor(endMin1-startMin1) + Math.floor(endMin2-startMin2)
      //             }else {
      //               this.isShow = true
      //               this.isTime = true
      //               this.isDisplay = true
      //               let [Time1, Time2, Time3] = row.timeDescription.split(' ');
      //               let [startTime1, endTime1] = Time1.split('-');
      //               this.form.startTime1 = startTime1
      //               this.form.endTime1 = endTime1
      //               let [startTime2, endTime2] = Time2.split('-');
      //               this.form.startTime2 = startTime2
      //               this.form.endTime2 = endTime2
      //               let [startTime3, endTime3] = Time3.split('-');
      //               this.form.startTime3 = startTime3
      //               this.form.endTime3 = endTime3
      //               let [startHour1, startMin1] = this.form.startTime1.split(':').map(Number);
      //               let [endHour1, endMin1] = this.form.endTime1.split(':').map(Number);
      //               let [startHour2, startMin2] = this.form.startTime2.split(':').map(Number);
      //               let [endHour2, endMin2] = this.form.endTime2.split(':').map(Number);
      //               let [startHour3, startMin3] = this.form.startTime3.split(':').map(Number);
      //               let [endHour3, endMin3] = this.form.endTime3.split(':').map(Number);
      //               this.hour = Math.floor(endHour1-startHour1) + Math.floor(endHour2-startHour2) + Math.floor(endHour3-startHour3)
      //               this.min = Math.floor(endMin1-startMin1) + Math.floor(endMin2-startMin2) + Math.floor(endMin3-startMin3)
      //             }
      //           })
      //         }
      //     }
      //   ],
      // },
      currentPage: 1,
      pageSize: 10,
      total: 1,
      dialogFormVisible: false,
      formLabelWidth: '180px',
      diaTitle: '',
      btnType: '',
      rules: {
        schedulingName: [
          { required: true, message: this.$t('ShiftSchedule.PleaseEnterScheduleName'), trigger: 'blur' },
        ],
        shiftId: [
          { required: true, message: this.$t('ShiftSchedule.PleaseSelectApplicationSchedule'), trigger: 'change' }
        ],
        dateRange: [
          { required: true, message: this.$t('ShiftSchedule.PleaseSelectSchedulingDateRange'), trigger: 'change' }
        ],
      },
      form: {
        schedulingName: '',
        shiftId: '',
        dateRange: [],
        assertDate: '',
        applicationCar: '',
        applicationDriver: ''
      },
      // isShow: true,
      // isTime: false,
      // isDisplay: false,
      // RoleList: [],
      // dialogPowerVisible: false,
      // data: [],
      // defaultProps: {
      //   children: 'children',
      //   label: 'value',
      // },
      // keyList: [],
      // filterText: '',
      selected: [],
      id: '',
      hour: '4',
      min: '0',
      isDisabled: false,
      pickerOptions: {
        disabledDate(time) {
          // 禁用当前时间之前的日期
          return time.getTime() < Date.now();
        }
      }
      // rolePower: '',
      // companyId: '',
      // diaHidden: false,

      // isShow: true,
      // isTrue: false,
    };
  },
  // watch: {
  //   filterText(val) {
  //     this.$refs.tree.filter(val);
  //   }
  // },
  // created() {
  //   this.getRole()

  //   if (sessionStorage.getItem("userType") == 0) {
  //     this.isShow = true
  //   } else {
  //     this.isShow = false
  //   }
  // },
  computed: {
    combinedData() {
      return this.filteredData;
    }
  },
  mounted() {
    // console.log(this.$route.params)
    // if (this.$route.params) {
    //   this.id = this.$route.params.id
    //   this.name = this.$route.params.name
    // }
    this.getShift()
    this.getShiftList()
    
  },
  methods: {
    getShiftList() {
      let param = {
        companyId: sessionStorage.getItem("companyId"),
        schedulingName: this.formInline.schedulingName,
        shiftId: this.formInline.shiftId,
        pageNum: this.currentPage,
        pageSize: this.pageSize
      }
      this.$store.dispatch('ShiftSchedule/GET_SELECTSHIFTAPPLICATION', param).then(res => {
        if (res) {
          if (res.data.code == 200) {
            this.list = res.data.data.list
            this.$refs.page.CommandTotal = res.data.data.total
          }
        }
      })
    },
    getShift() {
      let param = {
        companyId: sessionStorage.getItem("companyId"),
      }
      this.$store.dispatch('ShiftSchedule/GET_CHOICESHIFTLIST', param).then(res => {
        if (res) {
          if (res.data.code == 200) {
            this.shiftList = res.data.data
          }
        }
      })
    },
    onSearch() {
      this.currentPage = 1
      this.getShiftList()
    },
    onClear() {
      this.formInline = {
        schedulingName: '',
        shiftId: ''
      }
      this.getShiftList()
    },
    handleSelectionChange(val) {
      this.selected = val
      
    },
    indexMethod(index) {
      return index * 1 + 1;
    },
    changeSize(item) {
      this.pageSize = item.pageSize
      this.currentPage = item.pageNum
      this.getShiftList();
    },
    handleRangeChange(range) {
      if (range && range.length === 2) {
        this.generateDatesFromRange(range[0], range[1]);
      } else {
        this.form.assertDate = [];
      }
    },
    generateDatesFromRange(start, end) {
      this.form.assertDate = [];
      const startDate = new Date(start);
      const endDate = new Date(end);
      
      // 确保开始日期不晚于结束日期
      if (startDate > endDate) return;
      
      // 生成日期范围内的所有日期
      const currentDate = new Date(startDate);
      while (currentDate <= endDate) {
        const dateStr = this.formatDate(currentDate);
        this.form.assertDate.push(dateStr);
        console.log(this.form.assertDate)
        currentDate.setDate(currentDate.getDate() + 1);
      }
    },
    formatDate(date) {
      if (!date) return '';
      
      const d = new Date(date);
      const year = d.getFullYear();
      const month = (d.getMonth() + 1).toString().padStart(2, '0');
      const day = d.getDate().toString().padStart(2, '0');
      
      return `${year}-${month}-${day}`;
    },
    handleMultiChange(dates) {
      this.form.assertDate = dates || [];
      if (!dates || dates.length === 0) {
        this.form.dateRange = [];
      }
    },
    removeDate(date) {
      const index = this.form.assertDate.indexOf(date);
      if (index > -1) {
        this.form.assertDate.splice(index, 1);
      }
    },
    addShift() {
      this.dialogFormVisible = true;
      this.diaTitle = this.$t('common.btn.add')
      this.btnType = 'add'
      this.isDisabled = false
      // this.keyList = []
      this.$nextTick(() => {
        this.$refs.form.resetFields()
        this.form.applicationCar = ''
        this.form.applicationDriver = ''
        this.$refs.transfer.leftCheckList = []
        this.$refs.transfer.leftCheckAll = false
        this.$refs.transfer.leftIsIndeterminate = false
        this.$refs.transfer.rightCheckList = []
        this.$refs.transfer.rightCheckAll = false
        this.$refs.transfer.rightIsIndeterminate = false
        this.$refs.transfer.isDisabled = false
      })
    },
    editShift() {
      this.dialogFormVisible = true;
      this.diaTitle = this.$t('common.btn.edit')
      this.btnType = 'edit'
      this.isDisabled = false
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
        this.id = this.selected[0].id
        this.form.schedulingName = this.selected[0].schedulingName
        this.form.shiftId = this.selected[0].shiftId
        this.form.assertDate = this.selected[0].assertDate.split(",")
        this.form.dateRange = [this.selected[0].startDate,this.selected[0].endDate]
        this.form.applicationCar = this.selected[0].applicationCar.split(",")
        this.$refs.transfer.leftCheckList = this.selected[0].applicationCar.split(",")
        this.form.applicationDriver = this.selected[0].applicationDriver.split(",")
        this.$refs.transfer.rightCheckList = this.selected[0].applicationDriver.split(",")
        this.$refs.transfer.isDisabled = false
      })
    },
    editRowShift(row) {
      this.dialogFormVisible = true;
      this.diaTitle = this.$t('common.btn.edit')
      this.btnType = 'edit'
      this.isDisabled = false
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
        this.id = row.id
        this.form.schedulingName = row.schedulingName
        this.form.shiftId = row.shiftId
        this.form.assertDate = row.assertDate.split(",")
        this.form.dateRange = [row.startDate,row.endDate]
        this.form.applicationCar = row.applicationCar.split(",")
        this.$refs.transfer.leftCheckList = row.applicationCar.split(",")
        this.form.applicationDriver = row.applicationDriver.split(",")
        this.$refs.transfer.rightCheckList = row.applicationDriver.split(",")
        this.$refs.transfer.isDisabled = false
      })
    },
    carChange(e) {
      this.form.applicationCar = e
    },
    driverChange(e) {
      this.form.applicationDriver = e
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.form)
          let startDate = ''
          let endDate = ''
          if (this.form.dateRange) {
              if (this.form.dateRange.length > 0) {
                  startDate = this.form.dateRange[0]
                  endDate = this.form.dateRange[1]
              }
          }
          let assertDate = this.form.assertDate
          let param = {
            companyId: sessionStorage.getItem("companyId"),
            schedulingName: this.form.schedulingName,
            shiftId: this.form.shiftId,
            startDate: startDate,
            endDate: endDate,
            assertDate: assertDate.join(','),
            applicationCar: this.form.applicationCar.join(','),
            applicationDriver: this.form.applicationDriver.join(','),
          }
          console.log(param)
          if (this.btnType == 'add') {
            this.$store.dispatch('ShiftSchedule/GET_INSERTSHIFTAPPLICATION', param).then(res => {
              if (res.data.code == 200) {
                this.$message.success({
                  message: res.data.data,
                  duration: 6000,
                })
                this.dialogFormVisible = false;
                this.getShiftList();
                this.closeDia();
              } else {
                this.$message.error(res.data.msg)
              }

            }).catch(err => { })
          } else {
            param.id = this.id
            this.$store.dispatch('ShiftSchedule/GET_UPDATESHIFTAPPLICATION', param).then(res => {
              if (res.data.code == 200) {
                // this.$message.success(this.$t('PlatformSettings.form.editUserSuccess'))
                this.$message.success({
                  message: res.data.data,
                  duration: 6000,
                })
                this.dialogFormVisible = false;
                this.getShiftList();
                this.closeDia();
              } else {
                this.$message.error(res.data.msg)
              }

            }).catch(err => { })
          }
        } else {
          return false;
        }
      });
    },
    cancle(formName) {
      this.dialogFormVisible = false;
      this.form = {
        schedulingName: '',
        shiftId: '',
        dateRange: [],
        assertDate: '',
        applicationCar: '',
        applicationDriver: ''
      }
    },
    closeDia() {
      this.form = {
        schedulingName: '',
        shiftId: '',
        dateRange: [],
        assertDate: '',
        applicationCar: '',
        applicationDriver: ''
      }
      this.dialogFormVisible = false;
    },

    deleteShift() {
      this.$confirm(this.$t('common.btn.confirmDelete'), this.$t('common.btn.hint'),
        {
          cancelButtonText: this.$t('common.btn.cancel'),
          confirmButtonText: this.$t('common.btn.confirm'),
          type: 'warning'
        }).then(res => {
          let param = { id: this.id }
          this.$store.dispatch('ShiftSchedule/GET_DELETESHIFTAPPLICATION', param).then(response => {
            if (response.data.code == 200) {
              this.getShiftList()
              this.$message.success(this.$t('common.btn.deleteSuccess'))
            } else {
              this.$message.error(response.data.msg)
            }
          }).catch(error => { })
        }).catch(err => {
        })
    },
    deleteRowShift(row) {
      this.$confirm(this.$t('common.btn.confirmDelete'), this.$t('common.btn.hint'),
        {
          cancelButtonText: this.$t('common.btn.cancel'),
          confirmButtonText: this.$t('common.btn.confirm'),
          type: 'warning'
        }).then(res => {
          let param = { id: row.id }
          this.$store.dispatch('ShiftSchedule/GET_DELETESHIFTAPPLICATION', param).then(response => {
            if (response.data.code == 200) {
              this.getShiftList()
              this.$message.success(this.$t('common.btn.deleteSuccess'))
            } else {
              this.$message.error(response.data.msg)
            }
          }).catch(error => { })
        }).catch(err => {
        })
    },
    handleClick(row) {
      this.dialogFormVisible = true;
      this.diaTitle = this.$t('common.btn.detail')
      this.btnType = 'detail'
      this.isDisabled = true
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
        this.id = row.id
        this.form.schedulingName = row.schedulingName
        this.form.shiftId = row.shiftId
        this.form.assertDate = row.assertDate.split(",")
        this.form.dateRange = [row.startDate,row.endDate]
        this.form.applicationCar = row.applicationCar.split(",")
        this.$refs.transfer.leftCheckList = row.applicationCar.split(",")
        this.form.applicationDriver = row.applicationDriver.split(",")
        this.$refs.transfer.rightCheckList = row.applicationDriver.split(",")
        this.$refs.transfer.isDisabled = true
      })
    },
    queryDDetail() {
      // let param = {
      //   id: this.id,
      // }
      // this.$store.dispatch('ShiftSchedule/GET_SELECTAPPLICATION', param).then(res => {
      //   if (res) {
      //     if (res.data.code == 200) {
      //       this.form = res.data.data
      //       this.$nextTick(() => {
      //             this.$refs.form.clearValidate()
      //             // this.form.shiftName = row.shiftName
      //             // this.form.shiftType = row.shiftType
      //             if(this.form.shiftType == 1) {
      //               this.isShow = true
      //               this.isTime = false
      //               this.isDisplay = false
      //               let [startTime1, endTime1] = row.timeDescription.split('-');
      //               this.form.startTime1 = startTime1
      //               this.form.endTime1 = endTime1
      //               let [startHour1, startMin1] = this.form.startTime1.split(':').map(Number);
      //               let [endHour1, endMin1] = this.form.endTime1.split(':').map(Number);
      //               this.hour = Math.floor(endHour1-startHour1)
      //               this.min = Math.floor(endMin1-startMin1)
      //             }else if(this.form.shiftType == 2) {
      //               this.isShow = true
      //               this.isTime = true
      //               this.isDisplay = false
      //               let [Time1, Time2] = row.timeDescription.split(' ');
      //               console.log(Time1, Time2)
      //               let [startTime1, endTime1] = Time1.split('-');
      //               this.form.startTime1 = startTime1
      //               this.form.endTime1 = endTime1
      //               let [startTime2, endTime2] = Time2.split('-');
      //               this.form.startTime2 = startTime2
      //               this.form.endTime2 = endTime2
      //               let [startHour1, startMin1] = this.form.startTime1.split(':').map(Number);
      //               let [endHour1, endMin1] = this.form.endTime1.split(':').map(Number);
      //               let [startHour2, startMin2] = this.form.startTime2.split(':').map(Number);
      //               let [endHour2, endMin2] = this.form.endTime2.split(':').map(Number);
      //               this.hour = Math.floor(endHour1-startHour1) + Math.floor(endHour2-startHour2)
      //               this.min = Math.floor(endMin1-startMin1) + Math.floor(endMin2-startMin2)
      //             }else {
      //               this.isShow = true
      //               this.isTime = true
      //               this.isDisplay = true
      //               let [Time1, Time2, Time3] = row.timeDescription.split(' ');
      //               let [startTime1, endTime1] = Time1.split('-');
      //               this.form.startTime1 = startTime1
      //               this.form.endTime1 = endTime1
      //               let [startTime2, endTime2] = Time2.split('-');
      //               this.form.startTime2 = startTime2
      //               this.form.endTime2 = endTime2
      //               let [startTime3, endTime3] = Time3.split('-');
      //               this.form.startTime3 = startTime3
      //               this.form.endTime3 = endTime3
      //               let [startHour1, startMin1] = this.form.startTime1.split(':').map(Number);
      //               let [endHour1, endMin1] = this.form.endTime1.split(':').map(Number);
      //               let [startHour2, startMin2] = this.form.startTime2.split(':').map(Number);
      //               let [endHour2, endMin2] = this.form.endTime2.split(':').map(Number);
      //               let [startHour3, startMin3] = this.form.startTime3.split(':').map(Number);
      //               let [endHour3, endMin3] = this.form.endTime3.split(':').map(Number);
      //               this.hour = Math.floor(endHour1-startHour1) + Math.floor(endHour2-startHour2) + Math.floor(endHour3-startHour3)
      //               this.min = Math.floor(endMin1-startMin1) + Math.floor(endMin2-startMin2) + Math.floor(endMin3-startMin3)
      //             }
      //           })
      //     }
      //   }
      // })
    }

    // changeSort(item) {
    //   this.columns = [];
    //   this.$nextTick(function () {
    //     this.columns = item;
    //   });
    // },

    // ListSetting() {
    //   this.$refs.listSet.dialogVisible = true;
    // },
  },
};
